import { useRouter } from "next/router";
import { IGlobalSearchResponse, ISearchUnderlying, ISearchWikifolio } from "src/api/client/search-autocomplete.api.types";
import { useLinkBuilder } from "src/hooks/use-link-builder";
import { EnumSecurityType } from "src/types/common-enum";

export const useNavigateOnSelect = (results: IGlobalSearchResponse | null) => {
    const router = useRouter();
    const { buildUnderlyingLink, buildWikifolioLink, buildMarketIndicatorLink } = useLinkBuilder();

    const handleSelect = (selectedItem: ISearchWikifolio | ISearchUnderlying, selectedIndex: number) => {
        const isIndices = selectedItem.securityType === EnumSecurityType.Indices;

        const underlyingLink = isIndices
            ? buildMarketIndicatorLink(selectedItem.resourceIdentifier)
            : buildUnderlyingLink(selectedItem.resourceIdentifier);

        const url =
            results?.wikifolios && results.wikifolios?.length > selectedIndex ? buildWikifolioLink(selectedItem.resourceIdentifier) : underlyingLink;

        return router.push(url);
    };

    return { handleSelect };
};
